import Contacts from 'components/modules/Contacts/Contacts'

export default Contacts
